module.exports = __webpack_public_path__ + "img/p_171.9723f304.png";